import React, { useEffect } from "react";
import styled from "styled-components";
import { TitleHeader } from "../../TitleHeader";
import OrderForm from "./components/OrderForm";
import { Link, useNavigate } from "react-router-dom";
import { colors } from "../../../utils/theme";
import { useLocation } from "react-router-dom";
import { useDataContex } from "../../../hooks/Context/PatientProvider";

const Container = styled.div`
  width: 100%;
  margin-top: 2rem;
`;

const Session = styled.div`
  width: 90%;
  background-color: #f9f9f9;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 1px 1px 5px 1px #00000029;
`;

const ContainerOrder = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }

  .arrow {
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.primary};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

export const CurrentOrders = () => {
  const navigate = useNavigate();
  const { patientInfoContinuidadContex } = useDataContex();

  useEffect(() => {
    if (
      patientInfoContinuidadContex &&
      patientInfoContinuidadContex.orders.length === 0 &&
      patientInfoContinuidadContex.sesionesSinOrden.sesiones.length === 0
    ) {
      navigate("/CancelarCita");
    } else if (!patientInfoContinuidadContex) {
      navigate("/CancelarCita");
    }
  }, [patientInfoContinuidadContex, navigate]);

  const servicio = [patientInfoContinuidadContex];
  return (
    <Container>
      <TitleHeader title="CANCELA TU CITA" />
      <Session>
        <ContainerOrder>
          <div className="paginator">
            <Link className="arrow" to="/CancelarCita">
              <i className="bx bx-chevron-left"></i>
            </Link>
            <span className="title1">ORDENES MÉDICAS VIGENTES</span>
            <div></div>
          </div>

          {servicio.map((formularioData, index) => (
            <OrderForm key={index} data={formularioData} />
          ))}
        </ContainerOrder>
      </Session>
    </Container>
  );
};
